import type { Company } from '@/app/types/Company';

export function getCompanyDisplayName(company: Pick<Company, 'displayName' | 'name'> | null | undefined): string {
  return (company?.displayName || company?.name || '').trim();
}
